import React from 'react';
import { Link } from 'react-router-dom';

function StripeConnectBanner() {
  return (
    <div
      style={{
        marginBottom: '24px',
        padding: '16px 18px',
        borderRadius: '12px',
        border: '1px solid #fcd34d',
        backgroundColor: '#fffbeb',
        color: '#92400e',
        lineHeight: 1.5,
      }}
    >
      <strong style={{ display: 'block', marginBottom: '6px' }}>
        Connect Stripe to receive payouts
      </strong>
      <span>
        Your gear can be booked, but rental payouts are held until Stripe Connect is set up on your profile.
      </span>
      <div style={{ marginTop: '12px' }}>
        <Link
          to="/profile"
          style={{
            display: 'inline-block',
            padding: '10px 18px',
            backgroundColor: '#2563eb',
            color: '#ffffff',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
          }}
        >
          Connect Stripe on Profile
        </Link>
      </div>
    </div>
  );
}

export default StripeConnectBanner;